import React, { type ReactNode } from "react";

import { RecommendedProductData } from "../models/ugc";
import { Image } from "./Image";
import { RatingGraphic } from "./RatingGraphic";

interface IProps {
    recommendations: RecommendedProductData[];
}

export const UGCRecommendations = ({ recommendations }: IProps): ReactNode => {
    const buildProducts = () => {
        return recommendations.map((product, key) => {
            let productImage: React.JSX.Element | null = null;
            if (product.image_url) {
                productImage = (
                    <Image
                        className="ugc-recommends-product__image"
                        src={product.image_url}
                        alt=""
                    />
                );
            }
            return (
                <a
                    key={key}
                    className="ugc-recommends-product"
                    href={product.url}
                    target="_blank"
                    title={product.title}
                    rel="noreferrer"
                >
                    {productImage}
                    <div>
                        <div className="ugc-recommends-product__title">
                            {product.title}
                        </div>
                        <RatingGraphic
                            rating={product.rating}
                            numReviews={product.num_reviews}
                            cardClass={"ugc-recommends-product"}
                            cardSize={"small"}
                        />
                    </div>
                </a>
            );
        });
    };

    return (
        <section className="ugc-recommends">
            <div className="ugc-recommends__products">{buildProducts()}</div>
        </section>
    );
};

export default UGCRecommendations;
